import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'conditionsList', 'actionsList',
    'actionsContainer', 'rotationContainer', 'skipRoutingContainer'
  ]

  static CONDITION_FIELDS = [
    { value: 'ticket_category', label: 'Categoria do ticket' },
    { value: 'ticket_subcategory', label: 'Subcategoria do ticket' },
    { value: 'status', label: 'Status do contexto' },
    { value: 'authenticated_user_role', label: 'Papel do usuario' },
    { value: 'contract_id', label: 'ID do contrato' },
    { value: 'unit_id', label: 'ID da unidade' },
    { value: 'property_code', label: 'Codigo do imovel' },
    { value: 'property_city', label: 'Cidade do imovel' },
    { value: 'property_state', label: 'Estado do imovel' },
    { value: 'property_neighborhood', label: 'Bairro do imovel' },
    { value: 'event_type', label: 'Tipo de evento' },
    { value: 'maintenance_type', label: 'Tipo de manutencao' },
    { value: 'responsibility', label: 'Responsabilidade' },
    { value: 'urgency_level', label: 'Nivel de urgencia' },
    { value: 'conversation.assigned_user_id', label: 'Conversa atribuida' },
    { value: 'agent_phone', label: 'Numero do agente (WhatsApp)' },
    { value: 'billing_statuses', label: 'Status do boleto' },
    { value: 'max_billing_overdue_days', label: 'Dias de atraso do boleto' },
    { value: 'current_day_of_week', label: 'Dia da semana' },
    { value: 'current_hour', label: 'Hora do dia (0-23)' }
  ]

  static ACTION_FIELDS = [
    { value: 'resolved_user', label: 'Usuario resolvido' },
    { value: 'skip_routing', label: 'Pular roteamento' },
    { value: 'extra_payload', label: 'Payload extra' }
  ]

  connect() {
    this.conditionIndex = this._getNextIndex(this.conditionsListTarget, 'conditions')
    if (this.hasActionsListTarget) {
      this.actionIndex = this._getNextIndex(this.actionsListTarget, 'actions')
    }
  }

  typeChanged(event) {
    const type = event.target.value
    const isSkipRouting = type === 'Transformer::SkipRouting'
    const isResolveRotation = type === 'Transformer::ResolveRotation'
    const isReplace = type === 'Transformer::Replace'

    if (this.hasActionsContainerTarget)
      this.actionsContainerTarget.classList.toggle('hidden', !isReplace)
    if (this.hasRotationContainerTarget)
      this.rotationContainerTarget.classList.toggle('hidden', !isResolveRotation)
    if (this.hasSkipRoutingContainerTarget)
      this.skipRoutingContainerTarget.classList.toggle('hidden', !isSkipRouting)
  }

  addCondition(event) {
    event.preventDefault()
    const index = this.conditionIndex++
    this.conditionsListTarget.insertAdjacentHTML('beforeend', this._buildConditionItem(index))
  }

  addAction(event) {
    event.preventDefault()
    const index = this.actionIndex++
    this.actionsListTarget.insertAdjacentHTML('beforeend', this._buildActionItem(index))
  }

  removeItem(event) {
    event.preventDefault()
    const item = event.currentTarget.closest('.condition-item, .action-item')
    if (item) item.remove()
  }

  // --- Private ---

  _getNextIndex(listElement, nameSegment) {
    if (!listElement) return 0
    const inputs = listElement.querySelectorAll(`[name*="[${nameSegment}]"]`)
    let maxIndex = -1
    inputs.forEach(input => {
      const match = input.name.match(new RegExp(`\\[${nameSegment}\\]\\[(\\d+)\\]`))
      if (match) {
        const idx = parseInt(match[1], 10)
        if (idx > maxIndex) maxIndex = idx
      }
    })
    return maxIndex + 1
  }

  _buildConditionItem(index) {
    const id = `condition-item-new-${Date.now()}-${index}`
    const prefix = `transformer[conditions][${index}]`
    const num = index + 1
    const fieldOptions = this.constructor.CONDITION_FIELDS
      .map(f => `<option value="${f.value}">${f.label}</option>`)
      .join('')

    return `
      <div id="${id}" class="bg-gray-50 border border-gray-200 rounded-lg p-4 condition-item"
           data-controller="lead-transformer-condition">
        <div class="flex items-center justify-between mb-3">
          <div class="flex items-center gap-2">
            <span class="inline-flex items-center justify-center w-5 h-5 rounded text-[10px] font-bold text-black flex-shrink-0"
                  style="background: linear-gradient(135deg, #FFDE45 0%, #FFD700 100%);">${num}</span>
            <h4 class="text-sm font-medium text-gray-700">Condicao ${num}</h4>
          </div>
          <button type="button"
                  class="inline-flex items-center px-1.5 py-0.5 rounded text-xs text-red-400 hover:text-red-600 hover:bg-red-50 transition-colors"
                  data-action="click->support-transformer-form#removeItem">Remover</button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
          <div class="form-control">
            <label class="label py-1"><span class="label-text text-xs font-medium text-gray-700">Campo</span></label>
            <select name="${prefix}[field]"
                    class="select select-bordered w-full"
                    data-lead-transformer-condition-target="field"
                    data-action="change->lead-transformer-condition#fieldChanged">
              <option value="">Selecione um campo</option>
              ${fieldOptions}
            </select>
          </div>
          <div class="form-control">
            <label class="label py-1"><span class="label-text text-xs font-medium text-gray-700">Operador</span></label>
            <select name="${prefix}[operator]"
                    class="select select-bordered w-full"
                    data-lead-transformer-condition-target="operator"
                    data-action="change->lead-transformer-condition#operatorChanged">
              <option value="">Selecione um operador</option>
              <optgroup label="Comparacao">
                <option value="equals">= E igual a</option>
                <option value="not_equals">!= E diferente de</option>
              </optgroup>
              <optgroup label="Texto">
                <option value="contains">Contem</option>
                <option value="not_contains">Nao contem</option>
                <option value="starts_with">Comeca com</option>
                <option value="ends_with">Termina com</option>
              </optgroup>
              <optgroup label="Presenca">
                <option value="present">Tem valor</option>
                <option value="blank">Esta vazio</option>
              </optgroup>
              <optgroup label="Numero">
                <option value="greater_than">&gt; Maior que</option>
                <option value="greater_than_or_equal">&gt;= Maior ou igual a</option>
                <option value="less_than">&lt; Menor que</option>
                <option value="less_than_or_equal">&lt;= Menor ou igual a</option>
              </optgroup>
            </select>
          </div>
          <div class="form-control" data-lead-transformer-condition-target="valueContainer">
            <label class="label py-1"><span class="label-text text-xs font-medium text-gray-700">Valor</span></label>
            <input type="text" name="${prefix}[value]"
                   class="input input-bordered w-full"
                   placeholder="valor de comparacao"
                   data-lead-transformer-condition-target="value" />
          </div>
        </div>
      </div>
    `
  }

  _buildActionItem(index) {
    const id = `action-item-new-${Date.now()}-${index}`
    const prefix = `transformer[actions][${index}]`
    const num = index + 1
    const fieldOptions = this.constructor.ACTION_FIELDS
      .map(f => `<option value="${f.value}">${f.label}</option>`)
      .join('')

    return `
      <div id="${id}" class="bg-gray-50 border border-gray-200 rounded-lg p-4 action-item">
        <div class="flex items-center justify-between mb-3">
          <div class="flex items-center gap-2">
            <span class="inline-flex items-center justify-center w-5 h-5 rounded text-[10px] font-bold text-black flex-shrink-0"
                  style="background: linear-gradient(135deg, #FFDE45 0%, #FFD700 100%);">${num}</span>
            <h4 class="text-sm font-medium text-gray-700">Acao ${num}</h4>
          </div>
          <button type="button"
                  class="inline-flex items-center px-1.5 py-0.5 rounded text-xs text-red-400 hover:text-red-600 hover:bg-red-50 transition-colors"
                  data-action="click->support-transformer-form#removeItem">Remover</button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div class="form-control">
            <label class="label py-1"><span class="label-text text-xs font-medium text-gray-700">Campo de Destino</span></label>
            <select name="${prefix}[target_field]" class="select select-bordered w-full">
              <option value="">Selecione um campo</option>
              ${fieldOptions}
            </select>
          </div>
          <div class="form-control">
            <label class="label py-1"><span class="label-text text-xs font-medium text-gray-700">Valor</span></label>
            <input type="text" name="${prefix}[value]"
                   class="input input-bordered w-full font-mono text-sm"
                   placeholder="Ex: {ticket_category} ou valor fixo" />
            <p class="mt-1 text-xs text-gray-500">
              Use <code class="bg-gray-100 px-1 rounded text-xs">{campo}</code> para valores dinamicos.
            </p>
          </div>
        </div>
      </div>
    `
  }
}
